import React, { useState } from 'react';
import Layout from './components/layout/Layout';
import Header from './components/layout/Header';
import CategoryFilter from './components/filters/CategoryFilter';
import CardGrid from './components/cards/CardGrid';
import ProfileModal from './components/modal/ProfileModal';
import LoadingSpinner from './components/common/LoadingSpinner';
import EmptyState from './components/common/EmptyState';
import ErrorState from './components/common/ErrorState';
import { useProfiles } from './hooks/useProfiles';
import { useFilter } from './hooks/useFilter';
import './styles/globals.css';

const App = () => {
  const { profiles, loading, error } = useProfiles();
  const { filteredProfiles, selectedCategory, filterByCategory } = useFilter(profiles);
  const [selectedProfile, setSelectedProfile] = useState(null);

  const handleCardClick = (profile) => {
    setSelectedProfile(profile);
  };

  const handleCloseModal = () => {
    setSelectedProfile(null);
  };

  return (
    <Layout>
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Filters */}
        {!loading && !error && (
          <CategoryFilter 
            selectedCategory={selectedCategory}
            onFilterChange={filterByCategory}
          />
        )}

        {/* Loading State */}
        {loading && <LoadingSpinner />}

        {/* Error State */}
        {error && <ErrorState message={error} />}

        {/* Cards Grid */}
        {!loading && !error && filteredProfiles.length > 0 && (
          <CardGrid 
            profiles={filteredProfiles}
            onCardClick={handleCardClick}
          />
        )}

        {/* Empty State */}
        {!loading && !error && filteredProfiles.length === 0 && (
          <EmptyState />
        )}
      </div>

      {/* Modal */}
      <ProfileModal 
        profile={selectedProfile}
        onClose={handleCloseModal}
      />
    </Layout>
  );
};

export default App;
